import { SpiffCommerceClient } from '@spiffcommerce/core'
import { getShopifyMetadata } from '../necklace-builder/hooks/useShopifyMetadata'

export const createSpiffClient = () => {
  const shopifyMetadata = getShopifyMetadata()
  const client = new SpiffCommerceClient({ applicationKey: shopifyMetadata?.spiffAppKey })

  const SPIFF_SERVER_URL = 'https://api.au.spiffcommerce.com'
  const SPIFF_API_URL = 'https://services.au.spiffcommerce.com'
  const SPIFF_HUB_URL = 'https://hub.au.spiffcommerce.com'

  client.configureUrls(SPIFF_HUB_URL, SPIFF_SERVER_URL, SPIFF_API_URL)
  return client
}

export const client = createSpiffClient()
